import { render } from "./AppTabNav.vue?vue&type=template&id=7f9a3a26&scoped=true"
import script from "./AppTabNav.vue?vue&type=script&lang=js"
export * from "./AppTabNav.vue?vue&type=script&lang=js"

import "./AppTabNav.vue?vue&type=style&index=0&id=7f9a3a26&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f9a3a26"]])

export default __exports__